export default __webpack_public_path__ + "static/media/baby-20.5e17779e.svg";